import { computed, defineComponent } from 'vue';
import EditorNodeWrapper from './EditorNodeWrapper.vue';
export default defineComponent({
    name: 'EditorNodeDivider',
    components: {
        EditorNodeWrapper,
    },
    props: {
        node: {
            type: Object,
            default: () => ({}),
        },
        blockWidthClass: { type: String, default: null },
        rowType: { type: String, default: null },
    },
    setup(props) {
        const dividerType = computed(() => { var _a, _b; return (_b = (_a = props.node) === null || _a === void 0 ? void 0 : _a.dividerType) === null || _b === void 0 ? void 0 : _b.toLowerCase(); });
        const dividerPadding = computed(() => { var _a, _b; return `padding-${(_b = (_a = props.node) === null || _a === void 0 ? void 0 : _a.dividerPadding) === null || _b === void 0 ? void 0 : _b.toLowerCase()}`; });
        const rowTypeClass = computed(() => { var _a; return `row-type-${(_a = props.rowType) === null || _a === void 0 ? void 0 : _a.toLowerCase()}`; });
        return {
            dividerType,
            dividerPadding,
            rowTypeClass,
        };
    },
});
